<template>
    <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="attendanceDate"
              :picker-date.sync="attendanceDate"
              :label="label"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="attendanceDate"
            no-title
            @input="menu = false"
            :allowed-dates="isAllowedDate"
          ></v-date-picker>
        </v-menu>
</template>

<script>
 
export default {
    name: 'DatePicker',
    props:{
        label: {
            type: String,
            default: 'Select Date',
        },
        selectedDate: {
            type: String,
            default: new Date().toISOString().substr(0, 10),
        },
        initialAllowedDates: {
            type: Array,
            default: function(){
                return [];
            }
        },
    },

    created() {
       //console.log('allowedDates: ',this.initialAllowedDates)
    },

    data: function(){
        return {
            menu: false,
            attendanceDate: this.selectedDate,
            allowedDates: []
        }
    },

    watch: {
        attendanceDate(newValue){
            this.$emit('date-selected', newValue);
        },

        selectedDate(newValue){
            console.log(newValue);
            this.attendanceDate = newValue
        },

        initialAllowedDates(newValue){
            this.allowedDates = newValue
        }

    },
    

    methods: {
        isAllowedDate(date){
            return this.allowedDates.includes(date);
        }
    },
}
</script>